import styled from '@emotion/styled';

import { COLORS } from '../../constants';

export const StyledExplanation = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  padding: 16px 0px 16px 24px;
  color: ${COLORS.blackOlive};
  border-top: 1px solid ${COLORS.verbsButtonActive};
  border-bottom: 1px solid ${COLORS.verbsButtonActive};
`;

export const StyledAccessCode = styled.div`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #006298;
  padding: 16px 0px 16px 24px;
  color: ${COLORS.seaBlue}!important;
`;
